module.exports = __webpack_public_path__ + "img/f_02.233b0a6.png";